module.exports = __webpack_public_path__ + "img/mobile.7ec713f0.png";